export default function identity (x) {
  return x
}



// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/src/utils/identity.js